export default __webpack_public_path__ + "static/media/CY.67e59751.svg";